import React from 'react'
import { FieldValues } from 'react-hook-form'

import { FormProps } from './types'

const Form = <T extends FieldValues>({
  id,
  formRef,
  control,
  isEditing,
  currency,
  children,
  onSubmit,
}: FormProps<T>) => {
  return (
    <form id={id} ref={formRef} onSubmit={onSubmit}>
      {(Array.isArray(children) ? children : [children]).map((child, index) => {
        return child?.props?.name || child?.props?.isFormElement
          ? React.createElement<T>(child.type, {
              ...{
                ...child.props,
                isEditing,
                currency,
                control,
                key: child.props.name || index,
              },
            })
          : child
      })}
    </form>
  )
}

export default Form
